import { getPostcodeCountriesData, getPostcodeCountryData } from 'Shared/lib/postcodes';
import usePostcodeDropdown from './usePostcodeDropdown';
import './Postcode.scoped.scss'

export default function PostCode({
  response,
  setResponse,
  type = "text",
  placeholder = "Type an answer...",
  disabled = false,
  className = '',
  settings = {}
}) {
  const targetCountry = window.ENV.IP_COUNTRY?.toUpperCase() || 'GB';
  const allCountries = !!(settings?.allCountries || false);
  const allowedCountries = settings?.allowedCountries || [window.ENV.COUNTRY?.toUpperCase() || 'GB'];
  const international = !!(settings?.international || false);

  const rawPostcodeCountries = getPostcodeCountriesData();
  const availableCountries = allCountries
    ? rawPostcodeCountries
    : rawPostcodeCountries.filter(country => allowedCountries.includes(country.ISO));

  let defaultCountry = window.ENV.COUNTRY?.toUpperCase() || 'GB';
  if (targetCountry && availableCountries.some(country => country.ISO === targetCountry)) {
    defaultCountry = targetCountry;
  } else if (!allCountries && availableCountries.length > 0) {
    if (!availableCountries.some(country => country.ISO === defaultCountry)) {
      defaultCountry = availableCountries[0].ISO;
    }
  }

  const parsedResponse = typeof response === 'string' 
    ? { postcode: response, country: defaultCountry } 
    : (response || { postcode: '', country: defaultCountry });

  const country = parsedResponse.country || defaultCountry;
  const postcode = parsedResponse.postcode || '';
  const showCountrySelector = international || allCountries || allowedCountries.length > 1;

  const handlePostcodeChange = (event) => {
    setResponse({ country, postcode: event.target.value.toUpperCase() });
  };

  const handleCountryChange = (selectedCountry) => {
    setResponse({ country: selectedCountry, postcode });
  };

  const {
    isDropdownOpen,
    dropdownRef,
    sortedCountries,
    matchingCountry,
    handleCountryChange: onCountrySelect,
    toggleDropdown
  } = usePostcodeDropdown(availableCountries, country, handleCountryChange);

  const activeCountryData = getPostcodeCountryData(country);

  const countryLi = (countryData) => (
    <li
      key={countryData.ISO}
      data-country-iso={countryData.ISO}
      className={`country ${country === countryData.ISO ? 'highlight' : ''} ${matchingCountry?.ISO === countryData.ISO ? 'highlight' : ''}`}
      onClick={() => onCountrySelect(countryData.ISO)}
      role="option"
      aria-selected={country === countryData.ISO}
    >
      <div className={`flag ${countryData.ISO.toLowerCase()}`}></div>
      <span className="country-name">{countryData.Country}</span>
    </li>
  );

  return (
    <div className={`answers grow ${className}`}>
      <div className="postcode-fields">
        <div className="input-group">
          <div className="react-tel-input" ref={dropdownRef}>
            {showCountrySelector && (
              <div 
                className={`flag-dropdown ${isDropdownOpen ? 'open' : ''}`}
                onClick={() => toggleDropdown(disabled)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleDropdown(disabled);
                  }
                }}
              >
                <div className="selected-flag">
                  <div className={`flag ${country.toLowerCase()}`}></div>
                  <div className={`arrow ${isDropdownOpen ? 'up' : ''}`}></div>
                </div>
              </div>
            )}

            <input
              id="postcode-input"
              className={`postcode-input ${showCountrySelector ? 'international-postcodes' : ''}`}
              placeholder={`E.g. ${activeCountryData?.Zip_Format || 'AA9 9AA'}`}
              onChange={handlePostcodeChange}
              type={type}
              disabled={disabled}
              value={postcode}
            />

            {showCountrySelector && isDropdownOpen && (
              <ul className="country-list">
                {sortedCountries.length > 0 && countryLi(sortedCountries[0])}
                {allCountries && <li className="divider"></li>}
                {sortedCountries.slice(1).map((countryData) => countryLi(countryData))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
